import { Injectable } from '@angular/core';
import { ServiceRouter } from '../../core/http-service-router.service';
import { Config } from '../../../config/config';
import { Environment } from '../../../config/environment';
import { AppUtil } from '../../../utils/app.util';
import { METHOD_TYPE } from '../../../constants/service.constants';
import { Observable, BehaviorSubject } from 'rxjs';
import { Appointment } from '../../../beans/dashboard/dashboard-module.bean';
import { MatDialog } from '@angular/material/dialog';
import { WordPressOverlayComponent } from '../../../modules/shared/modals/word-press-overlay/word-press-overlay.component';

@Injectable({
	providedIn: 'root',
})
export class SimplifiedAppointmentsService {
	/** Observable to check the upcoming appointments count */
	upcomingAppointmentsCount: BehaviorSubject<any>;
	/** boolean to decide if full width has to be applied */
	fullWidth: BehaviorSubject<boolean>;
	/** boolean to decide if my health has to be shown or not */
	myhealth: BehaviorSubject<boolean>;
	/** boolean to decide if phone no has to be shown or not */
	showPhone: BehaviorSubject<boolean>;
	constructor(
		private serviceRouter: ServiceRouter,
		private config: Config,
		private environment: Environment,
		public dialog: MatDialog
	) {
		this.upcomingAppointmentsCount = new BehaviorSubject<any>(0);
		this.fullWidth = new BehaviorSubject<boolean>(false);
		this.myhealth = new BehaviorSubject<boolean>(false);
		this.showPhone = new BehaviorSubject<boolean>(false);
	}

	getUpcomingAppointmentsCount(): BehaviorSubject<any> {
		return this.upcomingAppointmentsCount;
	}

	setUpcomingAppointmentCount(upcomingAppointmentCount) {
		this.upcomingAppointmentsCount.next(upcomingAppointmentCount);
	}

	/**
	 * Saves car service preferences
	 * @param pathParam path param
	 * @param body post body
	 */
	saveCarServicePreferences(pathParam, body): Observable<Appointment> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			AppUtil.constructUrlWithPathParams(this.config.url.simplifiedSchedulingApi.saveCarServicePreferences, [
				pathParam,
			]),
			METHOD_TYPE.GENERAL_POST,
			body
		);
	}

	/**
	 * gets appointment details for given appointment id
	 * @param pathParam appointmentId
	 */
	getAppointmentInfo(pathParam): Observable<Appointment> {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			AppUtil.constructUrlWithPathParams(this.config.url.simplifiedSchedulingApi.getAppoinmentDetails, [pathParam]),
			METHOD_TYPE.GENERAL_GET,
			''
		);
	}

	getCancelledAppointmentInfo(appointmentId) {
		return this.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			this.config.url.simplifiedSchedulingApi.getCancelledAppointmentDetails + `/${appointmentId}/cancel`,
			METHOD_TYPE.GENERAL_GET,
			''
		);
	}

	/**
	 * get function for @fullWidth
	 */
	showFullWidth(): BehaviorSubject<any> {
		return this.fullWidth;
	}

	/**
	 * set function for @fullWidth
	 */
	setFullWidth(fullWidth) {
		this.fullWidth.next(fullWidth);
	}

	/**
	 * get function for @myhealth
	 */
	showMyHealth(): BehaviorSubject<any> {
		return this.myhealth;
	}

	/**
	 * set function for @myhealth
	 */
	setShowMyHealth(myhealth) {
		this.myhealth.next(myhealth);
	}

	/**
	 * get function for @showPhone
	 */
	showPhoneNo(): BehaviorSubject<any> {
		return this.showPhone;
	}

	/**
	 * set function for @showPhone
	 */
	setShowPhoneNo(showPhone) {
		this.showPhone.next(showPhone);
	}

	/**
	 * Opens facility rating as overlay
	 */
	openFacilityRatingModal() {
		this.dialog.open(WordPressOverlayComponent, {
			width: '100vw',
			data: { url: 'https://covid19.ehe.health/member-reviews/' },
			autoFocus: false,
			panelClass: 'wp-overlay',
		});
	}

	/**
	 * Opens about exam overlay
	 */
	// DE-3698 This button opens COVID-19 FAQ, which is not required anymore
	// openAboutExamModal() {
	//   this.dialog.open(WordPressOverlayComponent, {
	//     width: '100vw',
	//     data: {url: 'https://covid19.ehe.health/exam-faqs/'},
	//     autoFocus: false,
	//     panelClass: 'wp-overlay'
	//   });
	// }

	/**
	 * Opens about clinic overlay
	 */
	openAboutClinicModal() {
		this.dialog.open(WordPressOverlayComponent, {
			width: '100vw',
			data: { url: 'https://covid19.ehe.health/overview/' },
			autoFocus: false,
			panelClass: 'wp-overlay',
		});
	}
}
